import { Link } from "react-router-dom"
const LoggedFooter = () => {
 return (
    <footer className="d-flex justify-content-center align-items-center p-4 w-100" style={{backgroundColor: '#2d2d2d'}}>
        <p>Have a question, found a bug or have any feedback? Please <Link to='/contact'>contact us.</Link></p>
    </footer>
 )
}
export default LoggedFooter